import React from "react";
import { Button, ButtonGroup } from "aible";

import styles from "./style.module.css";
import { LineInput } from "components/Inputs/LineInput";

import DatasetViewContainer from "containers/View/Dataset";
import BlueprintViewContainer from "containers/View/Blueprint";
import BlueprintItem from "containers/View/Item/BlueprintItem";
import DatasetItem from "containers/View/Item/DatasetItem";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const initialState = {
  title: "New Project",
  activeButton: "blueprint",
  selectedBlueprintActive: null,
  selectedDatasetActive: null
};

class ProjectModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  createProject() {
    const { updateCreateFromProject, updateLabel, handleOpenBlueprint, handleOpenDataset, updateTransform } =
      this.props;

    const { activeButton, title, selectedBlueprintActive, selectedDatasetActive } = this.state;

    this.handleClose();
    updateCreateFromProject(true);
    updateLabel("new", title);
    if (activeButton === "blueprint") {
      if (selectedBlueprintActive) {
        handleOpenBlueprint(selectedBlueprintActive.id);
      }
    } else {
      if (selectedDatasetActive) {
        updateTransform("new", undefined);
        handleOpenDataset(selectedDatasetActive.id);

        return Promise.resolve();
      }
    }
  }

  handleClose() {
    const { updateIsNewProjectModalOpen } = this.props;

    updateIsNewProjectModalOpen(false);
    this.setState(initialState);
  }

  switchActiveButton(buttonState, idButton) {
    if (buttonState !== idButton) {
      this.setState({ activeButton: idButton });
    }
  }

  render() {
    const { isNewProjectModalOpen, selectedBlueprint, getBlueprint, getDataset } = this.props;

    const { title, activeButton, selectedDatasetActive, selectedBlueprintActive } = this.state;

    const blueprintOn = activeButton === "blueprint";
    const datasetOn = activeButton === "dataset";

    const buttonIsDisabled = blueprintOn ? !selectedBlueprintActive : !selectedDatasetActive;

    return (
      <Dialog open={isNewProjectModalOpen} onOpenChange={() => this.handleClose()}>
        <DialogContent size="xl">
          <DialogHeader>
            <DialogTitle>Project Setup</DialogTitle>
          </DialogHeader>
        </DialogContent>
        <div className={styles.userSelections}>
          <div className={styles.userInputs}>
            <LineInput
              label={"Name Project"}
              value={title}
              onChange={(val) => {
                this.setState({ title: val });
              }}
              labelStyle={{ position: "absolute", marginTop: "-10px", fontSize: "12px", color: "#777" }}
              style={{ width: "100%", height: "45px", margin: "0px auto" }}
            />
            <div style={{ fontSize: "12px", color: "#777" }}>{"Create Project From: "}</div>
            <ButtonGroup className={styles.buttonGroupModal}>
              <Button
                id={"blueprint"}
                style={{ width: "50%" }}
                active={blueprintOn}
                onClick={() => this.switchActiveButton(activeButton, "blueprint")}
                disabled={selectedDatasetActive}
                title={selectedDatasetActive ? "Click 'Change Dataset' to enable switch to dataset option" : ""}
              >
                {"Blueprint"}
              </Button>
              <Button
                id={"dataset"}
                style={{ width: "50%" }}
                active={datasetOn}
                onClick={() => this.switchActiveButton(activeButton, "dataset")}
                disabled={selectedBlueprintActive}
                title={selectedBlueprintActive ? "Click 'Change Blueprint' to enable switch to dataset option" : ""}
              >
                {"Dataset"}
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {activeButton === "blueprint" ? (
          selectedBlueprintActive ? (
            <div className={styles.selectedTile}>
              <BlueprintItem id={selectedBlueprintActive.id} noHover noClick isTile />
              <div className={styles.buttonWrapperModal}>
                <Button type="secondary" onClick={() => this.setState({ selectedBlueprintActive: null })}>
                  Change Blueprint
                </Button>
              </div>
            </div>
          ) : (
            <BlueprintViewContainer
              isModal
              hideFirstTile
              onClick={(s) => this.setState({ selectedBlueprintActive: getBlueprint(s) })}
            />
          )
        ) : selectedDatasetActive ? (
          <div className={styles.selectedTile}>
            <DatasetItem id={selectedDatasetActive.id} noHover noClick isTile />
            <div className={styles.buttonWrapperModal}>
              <Button type="secondary" onClick={() => this.setState({ selectedDatasetActive: null })}>
                Change Dataset
              </Button>
            </div>
          </div>
        ) : (
          <DatasetViewContainer
            isModal
            blueprintId={selectedBlueprint}
            onClick={(s) => this.setState({ selectedDatasetActive: getDataset(s) })}
          />
        )}
        <DialogFooter>
          <Button type="secondary" onClick={() => this.handleClose()}>
            Close
          </Button>
          <Button disabled={buttonIsDisabled} type="primary" onClick={() => this.createProject()}>
            Start Project
          </Button>
        </DialogFooter>
      </Dialog>
    );
  }
}

export default ProjectModal;
